/** Get a given `YYYY-MM-DD` string and format it to `DD/MM/YYYY`. */
export function formatISOStringToDateString(date: string): string {
  if (!date) return "";

  const isoDateParts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);

  if (!isoDateParts) return date;

  const [, year, month, day] = isoDateParts;

  return `${day}/${month}/${year}`;
}
